<template>
    <div class="container">
        <div class="tw-grid tw-grid-cols-4 tw-gap-8">
            <DashboardNavigation :user="user"/>

            <div class="tw-col-span-3">
                <TheFilterForm :year.sync="year" @download="download"/>

                <hr class="tw-mx-0 tw-my-8">

                <TheOverviewPanel :user="user" :year="year"/>

                <TheValueChartPanel :user="user" :year="year"/>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios'
import download from 'downloadjs'
import moment from 'moment'
import store from '@/store'
import DashboardNavigation from '../DashboardNavigation'
import TheFilterForm from './TheFilterForm'
import TheOverviewPanel from './TheOverviewPanel'
import TheValueChartPanel from './TheValueChartPanel'

export default {
    components: {TheFilterForm, TheOverviewPanel, DashboardNavigation, TheValueChartPanel},

    model: {
        prop: 'user'
    },

    props: {
        user: {
            required: true
        }
    },

    data() {
        return {
            year: moment().format('YYYY'),
            shared: store
        }
    },

    methods: {
        download() {
            axios.post('/api/v1/reports/commission', {
                user_id: this.user.id,
                start: moment().year(this.year).startOf('year').format('YYYY-MM-DD'),
                end: moment().year(this.year).endOf('year').format('YYYY-MM-DD'),
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.shared.token
                },
                responseType: 'blob'
            })
                .then(response => {
                    download(response.data, response.headers['content-disposition'].slice(22, -1))
                })
        }
    }
}
</script>
